export const programming = {

  title: "Notes",

  description: `A carefully curated collection of resources and code snippets covering fundamental topics in Computer Science, designed to serve as a quick reference, ideal for revising core concepts, exploring algorithms, understanding system design patterns, and preparing for technical interviews or competitive programming.`,

  programmingPatterns: [
    {
      pattern: "MATHEMATICS",
      name: "Mathematics"

    },
    {
      pattern: "ARRAYS",
      name: "Arrays"

    },
    {
      pattern: "TWO_POINTERS",
      name: "Two Pointers"

    },
    {
      pattern: "SLIDING_WINDOW",
      name: "Sliding Window"

    },
    {
      pattern: "SORTING",
      name: "Sorting"

    },
    {
      pattern: "LINKED_LIST",
      name: "Linked List"

    },
    {
      pattern: "HASH_MAPS",
      name: "Hash Maps"

    },
    {
      pattern: "GREEDY_ALGORITHM",
      name: "Greedy Algorithm"

    },
    {
      pattern: "RECURSION",
      name: "Recursion"

    },
    {
      pattern: "RECURSION_AND_BACKTRACKING",
      name: "Recursion and Backtracking"

    },
    {
      pattern: "BINARY_SEARCH",
      name: "Binary Search"

    },
    {
      pattern: "STACK_AND_QUEUE",
      name: "Stack and Queue"

    },
    {
      pattern: "STRING",
      name: "String"
    },
    {
      pattern: "BINARY_TREE",
      name: "Binary Tree"
    },
    {
      pattern: "GRAPH",
      name: "Graph"
    },
    {
      pattern: "DYNAMIC_PROGRAMMING",
      name: "Dynamic Programming"
    },
    {
      pattern: "TRIE",
      name: "Trie"
    },
    {
      pattern: "MISCELLANEOUS",
      name: "Miscellaneous"
    },
  ],

  problemDifficulty: {
    "EASY": {
      name: "Easy",
      color: "#2ECC71"
    },
    "MEDIUM": {
      name: "Medium",
      color: "#F39C12"
    },
    "HARD": {
      name: "Hard",
      color: "#E74C3C"
    }
  },


  solutionType: {
    "PYTHON": {
      name: "Python Solution",
      iconifyIconId: "logos:python",
      // style: {
      //   color: "#3776AB",
      // },

    },
    "TEXT": {
      name: "Explanation",
      iconifyIconId: "ant-design:solution-outlined",
    },
    "C": {
      name: "C Solution",
      iconifyIconId: "simple-icons:c",
      style: {
        color: "#E94E32",
      },
    },
    "C++": {
      name: "C++ Solution",
      iconifyIconId: "simple-icons:cplusplus",
      style: {
        color: "#E94E32",
      },
    },
    "JAVA": {
      name: "Java Solution",
      iconifyIconId: "simple-icons:java",
      style: {
        color: "#f89820",
      },
    },
    "JAVASCRIPT": {
      name: "JavaScript Solution",
      iconifyIconId: "simple-icons:javascript",
      style: {
        backgroundColor: "#FFFFFF",
        color: "#F7DF1E",
      },
    },
  },

  notesPages: [
    {
      name: "Algorithm & Data Structures",
      imageUrl: "https://miro.medium.com/v2/resize:fit:1200/1*BtuHe_nyh2RqVnVsCHr4Hw.png",
      route: "/algorithms-datastructures",
      description: "Covers topics such as Arrays, Linked Lists, Trees, Graphs, Dynamic Programming, Sorting, Searching, Bit Manipulation, and more. Each topic includes problem statements, solutions (often in Python, Java, or C++), and links to external resources."
    },
    {
      name: "Low Level System Design",
      imageUrl: "https://miro.medium.com/v2/resize:fit:1200/0*IlFsEmd2uccyUGcp",
      route: "",
      description: "Comprehensive coverage of low-level system design concepts including Object-Oriented Design, Design Patterns, SOLID Principles, UML Diagrams, Database Design, and API Design. Each topic includes real-world examples, best practices, and implementation guidelines for building scalable and maintainable systems."
    },
    {
      name: "High Level System Design",
      imageUrl: "https://www.designgurus.io/_next/image?url=https%3A%2F%2Fstorage.googleapis.com%2Fdownload%2Fstorage%2Fv1%2Fb%2Fdesigngurus-prod.appspot.com%2Fo%2FproductImages%252FGrokkingSystemDesignFundamentals%252Fimg%3A554da31-0bfe-17f2-a1d-ac14af2376f6.png%3Fgeneration%3D1681218762369296%26alt%3Dmedia&w=3840&q=75&dpl=dpl_Byhp4YRJ2MqY2QWszDpsoeXpepsW",
      route: "",
      description: "Explore high-level system design concepts including Distributed Systems, Microservices Architecture, Load Balancing, Caching Strategies, Database Scaling, Message Queues, and System Reliability. Learn to design large-scale systems that can handle millions of users with high availability and performance."
    },
    {
      name: "AI-ML-DL",
      imageUrl: "https://computerhistory.org/wp-content/uploads/2020/08/Neural_network_example_crop.png",
      route: "",
      description: "Comprehensive guide to Artificial Intelligence, Machine Learning, and Deep Learning concepts. Covers Supervised/Unsupervised Learning, Neural Networks, Computer Vision, Natural Language Processing, Reinforcement Learning, and practical implementations using popular frameworks like TensorFlow and PyTorch."
    },

  ],


  competitiveProgrammingPlatforms: [
    {
      platform: "LeetCode",
      name: "LEET_CODE",
      link: "https://leetcode.com/tarang_98/",
      iconifyIconId: "simple-icons:leetcode",
      style: {
        color: "#f3b548",
      },
    },
    {
      platform: "Hackerrank",
      name: "HACKER_RANK",
      link: "https://www.hackerrank.com/tarang98?hr_r=1",
      iconifyIconId: "simple-icons:hackerrank",
      style: {
        color: "#49b463",
      },
    },
    // {
    //   platform: "Codechef",
    //   name: "CODE_CHEF",
    //   link: "https://www.codechef.com/users/tarang_98",
    //   iconifyIconId: "simple-icons:codechef",
    //   style: {
    //     color: "#9ea39f",
    //   },
    // },
    {
      platform: "GFG",
      name: "GFG",
      link: "https://auth.geeksforgeeks.org/user/tarangnair98/practice/",
      iconifyIconId: "simple-icons:geeksforgeeks",
      style: {
        color: "#157d2f",
      },
    },


  ],

}


